// extracted by mini-css-extract-plugin
export var quillEditor = "_ox-1";
export var variable = "_ox-0";